module.exports = __webpack_public_path__ + "img/brand-logo-8f02138.png";